export const activitiesConstants = {
    ACTIVITY_SELECTED: 'ACTIVITY_SELECTED',
    ACTIVITY_LEVEL: 'ACTIVITY_LEVEL',
    ACTIVITY_COACH: 'ACTIVITY_COACH',
    ACTIVITY_REQUEST: 'ACTIVITY_REQUEST',
    ACTIVITY_SUCCESS: 'ACTIVITY_SUCCESS',
    ACTIVITY_FAILED: 'ACTIVITY_FAILED',
    ACTIVITY_DEFAULT: 'ACTIVITY_DEFAULT',
    ACTIVITY_SHOW_SEANCE: 'ACTIVITY_SHOW_SEANCE'
}